import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import allCountries from './../data/selectableCountries.json'
import allTags from './../data/selectableTags.json'
import { Country, Filter, SelectableCountries, SelectableDate, SelectableTags, Tag } from '../modules/filters';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent implements OnInit, OnChanges {

  @Input() countries: string[] = [];
  @Input() tags: string[] = [];

  @Output() newFilterEvent = new EventEmitter<string>();

  public selectableDates: SelectableDate[] = [];
  public selectableCountries: SelectableCountries = allCountries;
  public selectableTags: SelectableTags = allTags;

  public filterCountry: Filter = { key: '', value: '' };
  public filterDate: Filter = { key: '', value: '' };
  public filterTags: Filter[] = [];

  public expand: boolean = true;

  ngOnInit() {
    this.setSelectableDates();
  }

  ngOnChanges() {
    this.setSelectableCountries();
    this.setSelectableTags();
  }

  private setSelectableDates() {
    for (let i = 0; i < 12; i++) {
      let date = new Date();
      date = new Date(date.setMonth(date.getMonth() + i));
      let month = date.getMonth() + 1;
      let monthString = month.toString();
      if(month <= 9) {
        monthString = '0' + monthString;
      }
      let key = date.getFullYear() + '-' + monthString;
      let value = date.toLocaleString('en', { month: 'long' }) + ' ' + date.getFullYear();
      this.selectableDates.push({ index: i, key: key, value: value });
    }
  }

  private setSelectableCountries() {
    let newSelectableCountries: Country[] = [];
    /*
    this.countries.forEach(country => {
      let c = allCountries.countries.find(allCounty => (allCounty.id.toUpperCase() === country.toUpperCase()) || (allCounty.country.toUpperCase() === country.toUpperCase()));
      if (c) {
        newSelectableCountries.push(c);
      }
    });
    */
    allCountries.countries.forEach(allCountry => {
      if (this.countries.includes(allCountry.id.toUpperCase())) {
        newSelectableCountries.push(allCountry);
      }
    });
    this.selectableCountries = { countries: newSelectableCountries };
  }

  private setSelectableTags() {
    this.removeUnselectableTags();

    let newSelectableTags: Tag[] = [];
    allTags.tags.forEach(allTag => {
      if (this.tags.includes(allTag.key) || this.tags.includes(allTag.value)) {
        newSelectableTags.push(allTag);
      }
    });
    this.selectableTags = { tags: newSelectableTags };
  }

  private removeUnselectableTags() {
    let removeTags: Tag[] = [];
    this.filterTags.forEach(filterTag => {
      if (!this.tags.includes(filterTag.key) && !this.tags.includes(filterTag.value)) {
        removeTags.push(filterTag);
      }
    });
    removeTags.forEach(tag => {
      this.removeTagsFilter(tag);
    });

  }

  updateAccordion() {
    this.expand = !this.expand;
    let content = (document.getElementById('filter-accordion-content') as HTMLDivElement);
    if (this.expand) {
      content.style.setProperty('max-height', 'none');
    } else {
      content.style.setProperty('max-height', '0px');
    }
  }

  updateDateFilter() {
    let filterDate = (document.getElementById('filter-date') as HTMLSelectElement);
    let key = filterDate.value;
    if (this.filterDate.key != key) {
      this.filterDate.key = key;
      this.filterDate.value = this.filterDate.key == '' ? '' : filterDate.options[filterDate.selectedIndex].text;
      this.updateFilter();
    }
  }
  
  removeDateFilter() {
    let filterDate = (document.getElementById('filter-date') as HTMLSelectElement);
    filterDate.value = '';
    filterDate.selectedIndex = 0;
    this.updateDateFilter();
  }

  updateCountryFilter() {
    let filterCountry = (document.getElementById('filter-country') as HTMLSelectElement);
    let key = filterCountry.value;
    if (this.filterCountry.key != key) {
      this.filterCountry.key = key;
      this.filterCountry.value = this.filterCountry.key == '' ? '' : filterCountry.options[filterCountry.selectedIndex].text;
      this.updateFilter();
    }
  }
  
  removeCountryFilter() {
    let filterCountry = (document.getElementById('filter-country') as HTMLSelectElement);
    filterCountry.value = '';
    filterCountry.selectedIndex = 0;
    this.updateCountryFilter();
  }

  updateTagsFilter(filterTag: Filter) {
    let index = this.filterTags.findIndex(tag => tag.key == filterTag.key);
    if (index !== -1) {
      this.filterTags.splice(index, 1);
    } else {
      this.filterTags.push({ key: filterTag.key, value: filterTag.value })
    }
    this.updateFilter();
  }

  removeTagsFilter(filterTag: Filter) {
    (document.getElementById('search_filter_' + filterTag.key) as HTMLInputElement).checked = false;
    this.updateTagsFilter(filterTag);
  }

  resetFilter() {
    // Remove Date
    let filterDate = (document.getElementById('filter-date') as HTMLSelectElement);
    filterDate.value = '';
    filterDate.selectedIndex = 0;
    this.filterDate.key = '';
    this.filterDate.value = this.filterDate.key == '' ? '' : filterDate.options[0].text;

    // Remove Country
    let filterCountry = (document.getElementById('filter-country') as HTMLSelectElement);
    filterCountry.value = '';
    filterCountry.selectedIndex = 0;
    this.filterCountry.key = '';
    this.filterCountry.value = this.filterCountry.key == '' ? '' : filterCountry.options[0].text;

    // Remove Tags
    let tags = [];
    for (let i = 0; i < this.filterTags.length; i++) {
      tags.push(this.filterTags[i]);
    }
    tags.forEach(tag => {
      (document.getElementById('search_filter_' + tag.key) as HTMLInputElement).checked = false;
      let index = this.filterTags.findIndex(t => t.key == tag.key);
      if (index !== -1) {
        this.filterTags.splice(index, 1);
      } else {
        this.filterTags.push({ key: tag.key, value: tag.value })
      }
    });
    this.updateFilter();
  }
  
  private async updateFilter() {
    let filterString = '';
    if (this.filterCountry.key.length > 0 || this.filterDate.key.length > 0 || this.filterTags.length > 0) {
      filterString = '?';
      if (this.filterCountry.key.length > 0) {
        filterString = filterString + 'country=' + this.filterCountry.key;
      }
      if (this.filterDate.key.length > 0) {
        if (filterString !== '?') {
          filterString = filterString + '&'
        }
        filterString = filterString + 'date=' + this.filterDate.key;
      }
      if (this.filterTags.length > 0) {
        if (filterString !== '?') {
          filterString = filterString + '&'
        }
        let filterTagKeys: string[] = [];
        this.filterTags.forEach(filterTag => {
          filterTagKeys.push(filterTag.key);
        });
        filterString = filterString + 'tags=' + filterTagKeys.toString();
      }
    }
    this.newFilterEvent.emit(filterString);
  }

}
